import classNames from 'classnames';
import ImageTitle from 'src/components/articledisplays/ImageTitle';
import { ASPECT_2_1 } from 'src/components/articledisplays/ImageTitleAspect2_1';
import { ASPECT_PANORAMA } from 'src/components/articledisplays/ImageTitleAspectPanorama';
import { ASPECT_SQUARE } from 'src/components/articledisplays/ImageTitleAspectSquare';
import { isAdContent } from "src/components/forsiden/utilsv2";
import styles from './ArticleRowBlockV2.module.css';
import { GroupedLayoutObject, IArticleRowBlock, ISquareArticleRowBlock, PublishableDocument, ThemeValues } from "src/lib/types/IForsidenV2";
import IMovieList from "src/lib/types/MovieList";


//#region [Props]
type ArticleRowBlockProps = {
    block: GroupedLayoutObject<IArticleRowBlock | ISquareArticleRowBlock>;
    isSquare?: boolean;
};
//#endregion

const SIZES_THREE = `(min-width: 1641px) 546.666px, ((max-width: 1640px) and (min-width: 550px)) 33vw, 100vw`;
const SIZES_TWO = `(min-width: 1641px) 820px, ((max-width: 1640px) and (min-width: 550px)) 50vw, 100vw`;
const SIZES_SINGLE = `(min-width: 1641px) 1640px, 100vw`;

const SIZES = [SIZES_SINGLE, SIZES_TWO, SIZES_THREE];

//#region [Component]
export default function ArticleRowBlockV2({ block, isSquare = false }: ArticleRowBlockProps) {
    if ((block?.articles?.length ?? 0) === 0) return null;
    let aspect = block!.articles!.length === 1 ? ASPECT_PANORAMA : ASPECT_2_1;
    let maxArticles = 3;
    if (isSquare) {
        aspect = ASPECT_SQUARE;
        maxArticles = 2;
    }
    const articles = block.articles!.slice(0, maxArticles) as Exclude<PublishableDocument, IMovieList>[];

    return <div className={classNames(styles.SArticleRowBlock)}>
        {articles!.map((a, index) => {

            if (!a) {
                return null;
            }
            return <ImageTitle
                key={`${a._id}_${index}`}
                className={classNames(styles.SImageTitle, {
                    [styles.articles1]: block!.articles!.length === 1,
                    [styles.articles2]: block!.articles!.length === 2,
                    [styles.articles3]: block!.articles!.length >= 3
                })}
                sizes={isSquare ? SIZES[1] : SIZES[block!.articles!.length - 1]}
                forcedAspect={aspect}
                document={a}
                themeValue={block[`themes${index}`] as (ThemeValues | undefined)}
                isContentAd={isAdContent(a)}
                useSectionTitle />
        })
        }

    </div>;
}
//#endregion

//#region [Styles]
// Moved to CSS Modules (ArticleRowBlockV2.module.css)
//#endregion
